
const PASSCODE_LIST_EVENT_UUID_SEPARATOR = '___';
export const getDisplayName = (name: string | undefined, defaultDisplay?: string) => {
	if (!name) return defaultDisplay || '';
	const index = name.indexOf(PASSCODE_LIST_EVENT_UUID_SEPARATOR);
	return index === -1 ? name : name.slice(0, index);
};
